<template>
  <div>
    <navigation>
      <template #action>
        <slot name="navigation_action"/>
      </template>

      <template #content>
        <slot name="navigation_content"/>
      </template>
    </navigation>

    <div class="card-spacing" />

    <div
      :class="noStyling ? '' : 'card pa4'"
      class="page_content"
    >
      <slot/>
    </div>

    <div class="card-spacing" />

  </div>
</template>

<script>
import Navigation from '@/components/Navigation.vue';

export default {
  name: 'page',

  components: { Navigation },

  props: {
    noStyling: { type: Boolean, default: false },
  },
};
</script>

<style lang="scss">
.page_content {
  min-height: 100px;
}
</style>
